'use client'

import {useEffect} from "react"
import Lenis from "@studio-freight/lenis"
import {ScrollTrigger} from "gsap/ScrollTrigger"
import {gsap} from "gsap"

gsap.registerPlugin(ScrollTrigger)

// Lenis - Smooth scroll
export const createLenis = () => {
	if (typeof window !== 'undefined') {
		const lenis = new Lenis()

		window.lenis = lenis

		lenis.on('scroll', ScrollTrigger.update)

		gsap.ticker.add((time) => {
			lenis.raf(time * 1000)
		})

		gsap.ticker.lagSmoothing(0)
	}
}

const useSmoothScroll = () => {
	useEffect(() => {
		createLenis()

		// Makes sure we are at the top of the page when we refresh
		lenis.scrollTo(0, {immediate: true})

		return () => {
			lenis.scrollTo(0, {immediate: true})
			lenis.destroy()
		}
	}, [])
}

export default useSmoothScroll
